import { ReactNode } from "react";

import { DialogActions, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  actions: {
    padding: "20px 25px"
  }
}));

const ModalFooter = (props: { children: ReactNode }) => {
  const { children } = props;

  const classes = useStyles();

  return <DialogActions className={classes.actions}>{children}</DialogActions>;
};

export default ModalFooter;
